<template>
  <vx-card class="lg:p-8 w-full lg:w-9/12 fadeInLeft">
    <div v-if="isAuth">
      <div class="vx-card__title mb-6">
        <h4 class="mb-4">Здравствуйте, {{ authUser.name }}</h4>
        <p>Чтобы пользоваться сервисом необходимо подтвердить почту</p>
      </div>
      <div class="flex">
        <vs-button
          :disabled="alreadySent"
          @click.prevent="handleClickResend">Выслать ссылку повторно</vs-button>
        <vs-button
          class="ml-4"
          type="flat"
          @click.prevent="handleClickChangeAccount">Войти в другой аккаунт</vs-button>
      </div>
    </div>
  </vx-card>
</template>

<script>
import { mapGetters } from 'vuex'
import Auth from '../../api/http/models/auth/Auth'

export default {
  data () {
    return {
      alreadySent: false
    }
  },

  computed: mapGetters(['isEmailVerified', 'isAuth', 'authUser']),

  created () {
    if (this.isEmailVerified) {
      this.$router.push({ name: 'home' })
    }
  },

  methods: {
    async handleClickResend () {
      const response = await Auth.verifyResend()
      this.alreadySent = true

      if (response.status === 'success') {
        this.$vs.notify({
          color: 'success',
          title: 'На вашу почты было отправлено сообщение',
          text: ''
        })
      } else {
        this.$vs.notify({
          color: 'danger',
          title: 'Произошла ошибка',
          text: ''
        })
      }
    },

    async handleClickChangeAccount () {
      const response = await Auth.logout()
      if (response.status === 'success') {
        document.location = '/'
      }
    }
  }
}
</script>

